class TCaptcha{
  getTCaptcha(callback){
    try {
      const captcha1 = new TencentCaptcha('2003333921', (ret)=>this.callback(ret,callback),  { needFeedBack: false })
      captcha1.show() // 显示验证码
    } catch (error) {
      this.loadErrorCallback()
    }
  }
  callback(res,slide){
    /* res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
       res（客户端出现异常错误 仍返回可用票据） = {ret: 0, ticket: "String", randstr: "String", errorCode: Number, errorMessage: "String"}
       res（用户主动关闭验证码）= {ret: 2}
    */
    if (res.ticket && res.randstr && res.ret === 0 && !res.errorCode){ // 滑动成功
      Vue.prototype.$http.post('/captcha',{
        Ticket: res.ticket,
        Randstr: res.randstr,
      }).then(res=>{
        res.data.status === 'error' ? Vue.prototype.$store.commit('noticeErrorMsg','验证失败，请稍后重试') : slide(res.data)
      }).catch(err=> {
        Vue.prototype.$store.commit('noticeErrorMsg','网络异常，请稍后重试')
      })
    }else if(res.ret !== 2){ // 当用户非手动关闭时验证码时触发
      Vue.prototype.$store.commit('noticeErrorMsg','验证码加载错误或超时，请稍后重试')
    }
  }
  // 验证码js加载错误处理
  loadErrorCallback(){
    let CaptchaAppId = ''
    // 生成票据或自行做其它处理
    let ticket = 'terror_1001_' + CaptchaAppId + Math.floor(new Date().getTime() / 1000)
    this.callback({
      ret: 0,
      randstr: '@'+ Math.random().toString(36).substr(2),
      ticket: ticket,
      errorCode: 1001,
      errorMessage: 'jsload_error',
    })
  }
}
export default TCaptcha
